module.exports = __webpack_public_path__ + "static/media/12.d394300b.png";